import { Component, AfterViewInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-panel-detail-maintenance',
    templateUrl: './panel-detail-maintenance.component.html',
    styleUrls: ['./panel-detail-maintenance.component.css']
})
export class PanelDetailMaintenanceComponent implements ICellRendererAngularComp, AfterViewInit, OnDestroy {
    public data: any = {};
    private params!:any
    @ViewChild('root', { static: false }) rootRef!: ElementRef<HTMLElement>;
    private resizeObserver?: ResizeObserver;
    role:string = '';

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.role = this.params?.role;
        const d = params?.data || (params as any)?.node?.data || {};
        this.data = d && d.__isDetail ? d.master : d;
        setTimeout(() => this.updateRowHeight(), 0);
        setTimeout(() => this.updateRowHeight(), 100);
    }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        const d = params?.data || (params as any)?.node?.data || {};
        this.data = d && d.__isDetail ? d.master : d;
        setTimeout(() => this.updateRowHeight(), 0);
        setTimeout(() => this.updateRowHeight(), 100);
        return true;
    }

    toLetter(index: number): string {
        const base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        if (index >= 0 && index < base.length) {
            return base[index];
        }
        return base[index % base.length];
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.updateRowHeight(), 0);
        setTimeout(() => this.updateRowHeight(), 100);
        if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.updateRowHeight());
            if (this.rootRef?.nativeElement) this.resizeObserver.observe(this.rootRef.nativeElement);
        }
    }

    ngOnDestroy(): void {
        try { this.resizeObserver?.disconnect(); } catch { }
    }

    private updateRowHeight(): void {
        try {
            const api: any = (this.params as any)?.api;
            const rowNode: any = (this.params as any)?.node;
            if (!api || !rowNode) return;
            const el: HTMLElement | null = this.rootRef?.nativeElement || null;
            const measured = Math.max(160, Math.min(((el?.scrollHeight || el?.offsetHeight || 0) + 16), 1200));
            if (typeof rowNode.setRowHeight === 'function') {
                rowNode.setRowHeight(measured);
                setTimeout(() => { try { api.onRowHeightChanged(); } catch { } }, 0);
            }
        } catch { }
    }

    public openModalEvidences(data:any){
        if (!this.params?.parent) { return; }
        this.params.parent.openModalEvidences(data)
    }

    public uploadFilePaymentInvoice(data:any){
        if (!this.params?.parent) { return; }
        this.params.parent.uploadFilePaymentInvoice(data)
    }

    get totalMaterialCost(): number {
        return this.calculateMaterialCost();
    }

    get totalRepairCost(): number {
        return this.calculateRepairCost();
    }

    get totalCost(): number {
        return this.calculateTotalCost();
    }

    private calculateMaterialCost(): number {
        if (!this.data?.material_requests || !Array.isArray(this.data.material_requests)) {
            return 0;
        }
        return this.data.material_requests.reduce((total: number, material: any) => {
            const cost = Number(material.cost) || 0;
            const otherCost = Number(material.other_cost) || 0;
            return total + cost + otherCost;
        }, 0);
    }

    private calculateRepairCost(): number {
        if (!this.data?.repair_requests || !Array.isArray(this.data.repair_requests)) {
            return 0;
        }
        return this.data.repair_requests.reduce((total: number, repair: any) => {
            const cost = Number(repair.cost) || 0;
            const otherCost = Number(repair.other_cost) || 0;
            return total + cost + otherCost;
        }, 0);
    }

    private calculateTotalCost(): number {
        return this.totalMaterialCost + this.totalRepairCost;
    }
}
